import { z } from "zod";

export type DetailedChain = {
  chainId: string;
  internalId: string;
  name: string;
  icon: string;
  explorer: {
    name: string;
    tokenUrlFormat: string;
    txUrlFormat: string;
    homeUrl: string;
  };
  rpc: {
    publicServersUrl: string[];
  };
};

// External chain id used by the exchanges
// Don't confuse with the EIP155 chain id
export const ExternalChainIdSchema = z.string();
export type ExternalChainId = z.infer<typeof ExternalChainIdSchema>;

// Internal chain id used by cede.store
// Don't confuse with the EIP155 chain id
export const InternalChainIdSchema = z.string();
export type InternalChainId = z.infer<typeof InternalChainIdSchema>;
